module.exports = __webpack_public_path__ + "static/media/star.1b681b87.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spill/static/star.svg
// module id = 197
// module chunks = 0